module.exports = __webpack_public_path__ + "img/quote_bg--desktop.1318786a.svg";